<script>
    import Section from "./Section.svelte";
    import RedButton from "./RedButton.svelte";
    import ButtonDefault from "./ButtonDefault.svelte";
    import Switch from "./Switch.svelte";

    export let gameDescription;
    export let settings;

</script>

{#each gameDescription.settingsStructure as settingStruct}
    
    <Section title={settingStruct.title} subtitle={settingStruct.description}>
        {#if settingStruct.controlType === 'int'}
            <input
            type="number"
            bind:value={settings[settingStruct.key]}
            />
        {:else if settingStruct.controlType === 'text'}
            <input
            type="text"
            bind:value={settings[settingStruct.key]}
            />
        {:else if settingStruct.controlType === 'titleValueList'}

            <div class="title-value-list-setting">
            {#if Array.isArray(settingStruct.data)}
                <select
                class="section_select"
                bind:value={settings[settingStruct.key]}
                >
                {#each settingStruct.data as item}
                    <option value={item.value}>{item.title}</option>
                {/each}
                </select>

                {#if settings[settingStruct.key] === "custom.txt"}
                <br>
                <textarea
                    class="section_textarea"
                    rows="6"
                    placeholder="Enter your custom words here..."
                    bind:value={settings[`${settingStruct.key}_custom`]}
                />
                {/if}
            {/if}
            </div>





        {:else if settingStruct.controlType === 'stringList'}
        
            <div class="string-list-setting">
                {#if Array.isArray(settings[settingStruct.key]) || (settings[settingStruct.key] = [], true)}
                    {#each settings[settingStruct.key] as item, index (index)}
                        <div
                        class="string-list-item pb-2 flex items-center gap-2"
                        >
                        <input
                            type="text"
                            class="flex-grow section_textfield"
                            bind:value={settings[settingStruct.key][index]}
                        />

                        <RedButton text={"Remove"} onClick={() => {
                            const list = [...settings[settingStruct.key]];
                            list.splice(index, 1);
                            settings[settingStruct.key] = list;
                            }} />                   

                        <ButtonDefault secondary={true} text={"↑"} useMargins={false} onClick={ () => {
                                const list = settings[settingStruct.key];
                                const temp = list[index - 1];
                                list[index - 1] = list[index];
                                list[index] = temp;
                                settings[settingStruct.key] = list; 
                            }}  />

                        <ButtonDefault secondary={true} text={"↓"} useMargins={false} onClick={ () => {
                                const list = settings[settingStruct.key];
                                const temp = list[index + 1];
                                list[index + 1] = list[index];
                                list[index] = temp;
                                settings[settingStruct.key] = list; 
                            }}  />

                        </div>
                    {/each}
                {/if}

                <ButtonDefault text={"Add Item"} onClick={ () => {
                                settings[settingStruct.key] = [...settings[settingStruct.key], '']
                            }}  />

            </div>
        {:else if settingStruct.controlType === 'boolean'}
            <Switch bind:checked={settings[settingStruct.key]} />
        {:else if settingStruct.controlType === 'select'}
            <select
                class="section_select" 
                bind:value={settings[settingStruct.key]} >
            {#each settingStruct.options as option}
                <option value={option}>{option}</option>
            {/each}
            </select>
        {/if}
        </Section>
    
{/each}




